import { ElementRef, inject, input, output, signal, viewChild, } from '@angular/core';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import { AudioTranscriptionInputComponent } from 'NewAngular/features/components/audio-transcription-input/audio-transcription-input.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i2 from "@angular/forms";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["dropdownMenu"];
const _c1 = ["agentFileInput"];
const _c2 = ["audioInput"];
function AgentUserInputComponent_For_11_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 15)(2, "div", 16)(3, "div", 17)(4, "div", 18);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 20);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 21)(9, "button", 22);
    i0.ɵɵlistener("click", function AgentUserInputComponent_For_11_Template_button_click_9_listener() { const $index_r3 = i0.ɵɵrestoreView(_r2).$index; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.removeFile($index_r3)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 23);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const file_r5 = ctx.$implicit;
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", file_r5.name, " ");
} }
function AgentUserInputComponent_Conditional_13_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-audio-transcription-input", 24, 1);
    i0.ɵɵlistener("transcribedText", function AgentUserInputComponent_Conditional_13_Template_ycn_audio_transcription_input_transcribedText_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onTranscribedText($event)); })("transcriptionCancel", function AgentUserInputComponent_Conditional_13_Template_ycn_audio_transcription_input_transcriptionCancel_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onTranscriptionCancel()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("placeholder", "Ask AI Agent...")("inputText", ctx_r3.textFormControl.value ?? "")("maxCanvasWidth", ctx_r3.maxAudioCanvasWidth());
} }
function AgentUserInputComponent_Conditional_14_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25)(1, "textarea", 26);
    i0.ɵɵlistener("keydown.enter", function AgentUserInputComponent_Conditional_14_Template_textarea_keydown_enter_1_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onEnter($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(2, "div", 27)(3, "div", 28)(4, "div", 29)(5, "div", 30)(6, "button", 31);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_14_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r7); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.toggleDropdown()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(7, "svg", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(8, "div", 33, 2)(10, "a", 34);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_14_Template_a_click_10_listener() { i0.ɵɵrestoreView(_r7); const ctx_r3 = i0.ɵɵnextContext(); const agentFileInput_r8 = i0.ɵɵreference(16); agentFileInput_r8.click(); return i0.ɵɵresetView(ctx_r3.isDropdownOpen.set(false)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(11, "svg", 35);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(12, "div", 36);
    i0.ɵɵtext(13, "Attach Files");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(14, "button", 37);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_14_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r7); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.startTranscription()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(15, "svg", 38);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(16, "button", 39);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_14_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r7); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.submit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(17, "svg", 40);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r3.textFormControl);
    i0.ɵɵadvance(4);
    i0.ɵɵclassProp("show", ctx_r3.isDropdownOpen());
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-expanded", ctx_r3.isDropdownOpen());
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("show", ctx_r3.isDropdownOpen());
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("tooltipTitle", "Dictation");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r3.textFormControl.value);
} }
export class AgentUserInputComponent {
    constructor() {
        this._fb = inject(FormBuilder);
        this._dropdownHelperService = inject(DropdownHelperService);
        this.maxAudioCanvasWidth = input(468, ...(ngDevMode ? [{ debugName: "maxAudioCanvasWidth" }] : []));
        this.dropdownMenu = viewChild('dropdownMenu', ...(ngDevMode ? [{ debugName: "dropdownMenu" }] : []));
        this.fileInput = viewChild('agentFileInput', ...(ngDevMode ? [{ debugName: "fileInput" }] : []));
        this.audioInput = viewChild('audioInput', ...(ngDevMode ? [{ debugName: "audioInput" }] : []));
        this.openNewChat = output();
        this.sendMessage = output();
        this.uploadedFiles = signal([], ...(ngDevMode ? [{ debugName: "uploadedFiles" }] : []));
        this.textFormControl = this._fb.control('');
        this.isDropdownOpen = signal(false, ...(ngDevMode ? [{ debugName: "isDropdownOpen" }] : []));
        this.isTranscribing = signal(false, ...(ngDevMode ? [{ debugName: "isTranscribing" }] : []));
    }
    ngAfterViewInit() {
        const dropdown = this.dropdownMenu();
        if (dropdown) {
            this._dropdownHelperService.setCloseHandler(dropdown.nativeElement, () => {
                if (this.isDropdownOpen()) {
                    this.isDropdownOpen.set(false);
                }
            });
        }
    }
    toggleDropdown() {
        this.isDropdownOpen.update((x) => !x);
    }
    onFileChange(event) {
        const target = event.target;
        if (target.files) {
            const newFiles = Array.from(target.files);
            this.uploadedFiles.update((existing) => {
                const combined = [...existing, ...newFiles];
                return this.getUniqueFiles(combined);
            });
        }
        this.clearFileInput();
    }
    getUniqueFiles(files) {
        return files.filter((file, index) => files.findIndex((f) => f.name === file.name &&
            f.size === file.size &&
            f.type === file.type &&
            f.lastModified === file.lastModified) === index);
    }
    removeFile(fileIndex) {
        this.uploadedFiles.update((files) => files.filter((_, i) => i !== fileIndex));
    }
    onEnter(event) {
        if (!this.textFormControl.value?.trim()) {
            event.preventDefault();
            return;
        }
        if (!event.shiftKey) {
            event.preventDefault();
            this.submit();
        }
    }
    ngOnDestroy() {
        const audioInput = this.audioInput();
        if (audioInput) {
            audioInput.cancelTranscription();
        }
    }
    submit() {
        this.sendMessage.emit({ text: this.textFormControl.value, files: this.uploadedFiles() });
        this.textFormControl.setValue('');
        this.uploadedFiles.update(() => []);
    }
    clearFileInput() {
        const fileInput = this.fileInput();
        if (fileInput) {
            fileInput.nativeElement.value = '';
        }
    }
    startTranscription() {
        this.isTranscribing.set(true);
        // wait for component to render, then trigger transcription
        setTimeout(() => this.audioInput()?.startTranscription());
    }
    onTranscriptionCancel() {
        this.isTranscribing.set(false);
    }
    onTranscribedText(text) {
        this.textFormControl.setValue(text.trim());
        this.isTranscribing.set(false);
    }
}
AgentUserInputComponent.ɵfac = function AgentUserInputComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentUserInputComponent)(); };
AgentUserInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentUserInputComponent, selectors: [["ycn-agent-user-input"]], viewQuery: function AgentUserInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.dropdownMenu, _c0, 5);
        i0.ɵɵviewQuerySignal(ctx.fileInput, _c1, 5);
        i0.ɵɵviewQuerySignal(ctx.audioInput, _c2, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance(3);
    } }, inputs: { maxAudioCanvasWidth: [1, "maxAudioCanvasWidth"] }, outputs: { openNewChat: "openNewChat", sendMessage: "sendMessage" }, decls: 17, vars: 1, consts: [["agentFileInput", ""], ["audioInput", ""], ["dropdownMenu", ""], [1, "d-flex", "justify-content-between", "w-full"], [1, "btn", "btn-transparent-rounded", 3, "click"], ["name", "icon-add", "ycnIcon", ""], [1, "text-smallest"], [1, "form-control-colors"], [1, "overflow-shadow-x"], [1, "overflow-shadow-inner"], [1, "d-flex", "pt-10"], [1, "plate-container"], [1, "d-flex", "justify-content-between", "flex-wrap"], [1, "flex-auto", 3, "placeholder", "inputText", "maxCanvasWidth"], ["type", "file", "multiple", "", "hidden", "", 3, "change"], [1, "plate", "plate-thin", "plate-noshadow", "plate-white"], [1, "plate-header", "width-full"], [1, "plate-title", "min-width-0"], [1, "plate-title-icon"], ["name", "icon-overview", "ycnIcon", ""], [1, "plate-title-name", "min-width-0", "text-ellipsis"], [1, "plate-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", "btn-close", 3, "click"], ["name", "icon-close", "ycnIcon", ""], [1, "flex-auto", 3, "transcribedText", "transcriptionCancel", "placeholder", "inputText", "maxCanvasWidth"], [1, "form-control-autosize", "max-rows-7", "relative", "flex-auto"], ["placeholder", "Ask AI Agent...", "rows", "1", 1, "field-input", "border-0", "ng-pristine", "ng-untouched", "ng-valid", "ng-empty", 3, "keydown.enter", "formControl"], [1, "d-flex", "align-items-end", "ml-auto", "pt-1", "pr-2", "pb-1", "width-full", "pl-2"], [1, "d-flex", "align-items-center", "justify-content-between", "width-full"], [1, "d-flex", "align-items-center"], [1, "dropdown", "mr-1"], ["role", "button", "aria-haspopup", "true", 1, "btn", "btn-24", "btn-circle", "btn-transparent", "btn-lightgray", "dropdown-toggle", 3, "click"], ["name", "icon-add-circle", "ycnIcon", ""], [1, "dropdown-menu", "dropdown-menu-with-icons"], ["href", "javascript:void(0)", 1, "dropdown-item", 3, "click"], ["name", "icon-attach", "ycnIcon", ""], [1, "dropdown-item-text"], ["ycnTooltip", "", 1, "btn", "btn-24", "btn-circle", "btn-transparent", "btn-lightgray", 3, "click", "tooltipTitle"], ["name", "icon-microphone", "ycnIcon", ""], [1, "btn", "btn-32", "btn-circle", "btn-ai-prompt", 3, "click", "disabled"], ["name", "icon-update", "ycnIcon", ""]], template: function AgentUserInputComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 3);
        i0.ɵɵelement(1, "div");
        i0.ɵɵelementStart(2, "button", 4);
        i0.ɵɵlistener("click", function AgentUserInputComponent_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.openNewChat.emit()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(3, "svg", 5);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(4, "span", 6);
        i0.ɵɵtext(5, "New Chat");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 7)(7, "div", 8)(8, "div", 9)(9, "div", 10);
        i0.ɵɵrepeaterCreate(10, AgentUserInputComponent_For_11_Template, 11, 1, "div", 11, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(12, "div", 12);
        i0.ɵɵconditionalCreate(13, AgentUserInputComponent_Conditional_13_Template, 2, 3, "ycn-audio-transcription-input", 13)(14, AgentUserInputComponent_Conditional_14_Template, 18, 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(15, "input", 14, 0);
        i0.ɵɵlistener("change", function AgentUserInputComponent_Template_input_change_15_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onFileChange($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(10);
        i0.ɵɵrepeater(ctx.uploadedFiles());
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.isTranscribing() ? 13 : 14);
    } }, dependencies: [IconModule, i1.IconDirective, ReactiveFormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlDirective, TooltipModule, i3.TooltipDirective, AudioTranscriptionInputComponent], encapsulation: 2, changeDetection: 0 });
